import { Box, Divider, Typography } from '@material-ui/core'
import PublicWrapper from '../public-wrapper-v2/public-wrapper'
import useSyncAccountingThankYouStyles from './sync-accounting-thank-you.styles'
import STATIC_TEXT from '../../content/common.json'
import Spacing from '../portico/spacing/spacing'
import backgroundImage from '../../assets/connect_page_bg.svg'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { logout } from '../../stores/async/identity-async-actions'

export const SyncAccountingThankYou = () => {
    const classes = useSyncAccountingThankYouStyles()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(logout())
    }, [])

    return (
        <div className={classes.trapezoidBg}>
            <PublicWrapper data-testid="publicWrapper" displayPrivacyPolicyFooter={true} contentWrapperClass={classes.thankYouWrapper}>
                <div className={classes.thankYouBox}>
                    <div className={classes.bannerTitle}>{STATIC_TEXT.syncAccountingThankYou.title}</div>
                    <div className={classes.heading}>{STATIC_TEXT.syncAccountingThankYou.heading}</div>
                    <div className={classes.additionalContent}>{STATIC_TEXT.syncAccountingThankYou.additionalContentNew}</div>
                </div>
            </PublicWrapper>
        </div>
    )
}
